require('./inputTime.scss');

const React = require('react');
const PropTypes = require('prop-types');

// @constants
const { INPUT_TIME_PLACEHOLDER } = require('constants/contactCenter/inputTime');

class InputTime extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            time: '',
            error: false,
        };
        this.lastVal = '';
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    handleBlur(evt){
        const { setTime, onBlur } = this.props;
        const value = evt.target.value;
        if(evt.target.value === '\s' || evt.target.value === '') {
            evt.target.placeholder = INPUT_TIME_PLACEHOLDER
        }

        setTime(value);
        onBlur();
    }

    isValid (value) {
        let isValid = true;
        const dividedTime = value.split(":").join("").split("");
        const regExp = /^\d{0,2}?\:?\d{0,2}$/;
        let subDividedTime = [];

        if (!regExp.test(value)) {
            isValid = false;
        }

        if (dividedTime[0] && (parseInt(dividedTime[0]) < 0) || (parseInt(dividedTime[0]) > 2)) {
            isValid = false;
        }

        if (dividedTime[2] && (parseInt(dividedTime[2]) < 0 || parseInt(dividedTime[2]) > 5)) {
            isValid = false;
        }

        subDividedTime.indexOf(':') ? subDividedTime = value.split(':') : subDividedTime.push(value);

        if (subDividedTime[0] && subDividedTime[0].length && (parseInt(subDividedTime[0]) < 0 || parseInt(subDividedTime[0], 10) > 23)) {
            isValid = false
        }

        if (subDividedTime[1] && subDividedTime[1].length && (parseInt(subDividedTime[1]) < 0 || parseInt(subDividedTime[1], 10) > 59)) {
            isValid = false;
        }

        return isValid;
    }
    handleOnChange (evt) {
        let value = evt.target.value;

        if (this.isValid(value)) {

            if(value === ':') {
                value = `00${value}`;
            }

            if (value.length === 2 && this.lastVal.length !== 3 && value.indexOf(':') === -1) {
                value = `${value}:`;
            }

            if (value.length === 2 && this.lastVal.length === 3) {
                value = value.slice(0, 1);
            }

            if(value.length === 5 && this.lastVal.length !== 6 && value.indexOf('h') === -1){
                value = `${value}h`;
            }

            if(value.length === 5 && this.lastVal.length === 6){
                value = value.slice(0,4);
            }

            this.lastVal = value;

            this.setState({
                time: value
            });

            value.length === 6 && this.props.setTime(value);
        }
    }

    render() {
        const { className, label, id} = this.props;

        let labelElement = null;
        const inputTimeClass = `${className} input-time`;
        const labelId = `lbl_${id}`;
        const inputId = `inp_${id}`;

        if (label) {
            labelElement = (
                <label id={labelId} className="input-time__label">
                    {label}
                </label>
            );
        }

        return (
            <div className={inputTimeClass}>
                {labelElement}
                <input
                    id={inputId}
                    placeholder={INPUT_TIME_PLACEHOLDER}
                    className="input-time__input"
                    value={this.state.time}
                    onChange={this.handleOnChange}
                    onBlur={this.handleBlur}
                    ref={(c) => this._input = c}
                />
            </div>
        );
    }
}

InputTime.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    setTime: PropTypes.func,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onBlur: PropTypes.func
};

InputTime.defaultProps = {
    disabled: false
};

module.exports = InputTime;
